import LOGO_B2B from "@website/widget/header/assets/logo-b2b.svg";
import LOGO_MINIMAL from "@website/widget/header/assets/logo-minimal.svg";
import LOGO from "@website/widget/header/assets/logo.png";
import LOGO_SNAPP from "@website/widget/header/assets/logo_snapp.svg";

export const logoSchema = {
  "snapp-ir": {
    label: "snapp",
    image: LOGO_SNAPP,
    title: "اسنپ"
  },
  b2b: {
    label: "snapptrip",
    image: LOGO_B2B,
    title: "اسنپ تریپ"
  },
  telesale: {
    label: "snapptrip",
    image: LOGO_B2B,
    title: "اسنپ تریپ"
  },
  default: {
    label: "snapptrip",
    image: LOGO,
    title: "اسنپ تریپ"
  },
  minimal: {
    label: "snapptrip",
    image: LOGO_MINIMAL,
    title: "اسنپ تریپ"
  }
} as const;
